import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { HttpClient } from '@angular/common/http';
import { RouteRowInfo, RouteTypeList } from 'src/app/models/RouteTypeList';
import { ImportFileType } from 'src/app/models/ImportFileType';
import { RouteSegmentsService } from 'src/app/services/route-segments.service';
import { ProjectService } from 'src/app/services/project.service';
import { Layer } from 'src/app/menu/view-menu/layer';
import { MapService } from 'src/app/services/map.service';
import { ConfigurationConstants } from 'src/app/models/EnumTypes';
import { Feature } from 'ol';
import Geometry from 'ol/geom/Geometry';
import { Route } from 'src/app/models/Route';
import { Segment } from 'src/app/models/Segment';
import { CreateProcedureFromRouteSegmentComponent } from '../../create-procedure-from-route-segment/create-procedure-from-route-segment.component';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { CoordenateService } from 'src/app/services/coordenate.service';

@Component({
  selector: 'app-routesegment-type-selection',
  templateUrl: './routesegment-type-selection.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class RoutesegmentTypeSelectionComponent implements OnInit {


  @Input()
  routeTypeMap: Map<string, RouteTypeList[]>;

  @Input()
  routeTypeRowExpanded: boolean[];

  @Input()
  formData: FormData

  @Input()
  isEad51: boolean;

  constructor(public bsModalRef: BsModalService,
    public http: HttpClient,
    public endpointService: EndpointsService,
    public confirmationModal : ModalConfirmationService,
    private modalService: ModalControlService,
    public routeSegmentsService : RouteSegmentsService,
    private projectService : ProjectService,
    private mapService: MapService,
    private uiBlock: UiBlockService,
    private pointsService: PointsService,
  private rcsControl: CoordenateService) { }

  ngOnInit(): void {
  }

  cancel():void{
    this.bsModalRef.hide();
  }


  static createRouteTypeMap( routeTypeList:RouteTypeList[]): Map<string, RouteTypeList[]>{
    const routeTypeMap = new Map<string, RouteTypeList[]>();
    let type: string;  
    for (const routeType of routeTypeList){
      type =  routeType.type;
      routeType.selected = false;
      if (routeTypeMap.has(type)){
        routeTypeMap.get(type).push(routeType);
      } else {
        routeTypeMap.set(type, [routeType]);
      }
    }
    return routeTypeMap;
  }

  static createRowActiveProperty(map: Map<string, RouteTypeList[]>): boolean[]{
    const toReturn: boolean[] = [];
    map.forEach(() => toReturn.push(false));
    return toReturn;
  }

  colapsableLabelRouteType(index : number): void {
    this.routeTypeRowExpanded[index] = !this.routeTypeRowExpanded[index];
  }

  changeSelectedChild(mapKey: string, index: number){
    this.routeTypeMap.get(mapKey)[index].selected = !this.routeTypeMap.get(mapKey)[index].selected;
  }

  changeSelectedParent(mapKey: string, event){
    if (event.target.checked){
      this.selectAllParent(mapKey);
    } else {
      this.deselectAllParent(mapKey);
    }
  }

  checkIfAllSelected(mapKey: string): boolean{
    for (const row of this.routeTypeMap.get(mapKey)){
      if (!row.selected){
        return false;
      }
    }
    return true;

  }

  selectAllParent(mapKey: string){
    for (const row of this.routeTypeMap.get(mapKey)){
      row.selected = true;
    }
  }

  deselectAllParent(mapKey: string){
    for (const row of this.routeTypeMap.get(mapKey)){
      row.selected = false;
    }
  }

  getRouteTypeSelected(): RouteTypeList[] {
    const toReturn: RouteTypeList[] = [];
    for (const routeTypes of this.routeTypeMap.values()){
      for (const row of routeTypes){
        row.selected? toReturn.push(row): false;
      }
    }
    return toReturn;
  }

  selectAll(){
    for (const key of this.routeTypeMap.keys()){
      this.selectAllParent(key);
    }
  }

  deselectAll(){
    for (const key of this.routeTypeMap.keys()){
      this.deselectAllParent(key);
    }
  }

  proceedWithImport(){
    this.confirmationModal.showMesssageConfirmationModal("Create Procedure", "Do you wish to create a Procedure from the imported Route Segments", "Yes", "No", () => {
      this.routeSegmentsService.isCreateProcedureFromRouteSegment = true;
      this.isEad51? this.importEAD51(): this.importEAD45();
    }, () =>{
      this.routeSegmentsService.isCreateProcedureFromRouteSegment = false;
      this.isEad51? this.importEAD51(): this.importEAD45();
    });
  }

  importEAD45(): void{
    const routesSelected = this.getRouteTypeSelected();  
    if (routesSelected.length == 0){
      this.modalService.showMesssageModal("Error", "Please select items to import.");
      return;
    }
    this.cancel();
    this.formData.append("routeTypes", JSON.stringify(routesSelected));
    this.uiBlock.startBlock('Parsing XML file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileRouteSegments + '/' + ImportFileType.ROUTESEGMENTS_EAD45_PHASE2,
        this.formData,
        this.endpointService.httpOptions
      )
      .subscribe((routes: RouteRowInfo[]) => {
        this.uiBlock.stopBlock();
        if (routes.length == 0){
          this.modalService.showMesssageModal('Route Segments','No Route Segments available to import.');
        } else {
          this.routeSegmentsService.modelXML.routeSegments = routes;
          this.saveRouteSegments();
        }
      }, (error) => {
        this.uiBlock.stopBlock();
        this.pointsService.handleImportError(error, "XML")
      })
  }

  importEAD51(): void{

    const routes: RouteRowInfo[] = [];
    const routesSelected = this.getRouteTypeSelected();  

    for (const routeType of routesSelected){
      if (routeType.routeRowInfo != null){
        const isNotNullish = routeType.routeRowInfo.endSegmentPointLatitude != null && routeType.routeRowInfo.endSegmentPointLongitude != null
                          && routeType.routeRowInfo.startSegmentPointLatitude != null && routeType.routeRowInfo.startSegmentPointLongitude != null;
      
        if (isNotNullish){
          routes.push(routeType.routeRowInfo)
        }
      }
    }

    if (routes.length == 0){
      this.modalService.showMesssageModal('Route Segments','No Route Segments available to import.');
    } else {
      this.cancel();
      this.routeSegmentsService.modelXML.routeSegments = routes;
      this.saveRouteSegments();
    }
  }

  saveRouteSegments(): void{
    this.routeSegmentsService.modelXML.features = this.routeSegmentsService.createFeaturesFromXMLContent();
    this.routeSegmentsService.saveState(this.routeSegmentsService.modelXML.saveData(), this.projectService.activeProject.id);
  
    if(this.routeSegmentsService.isCreateProcedureFromRouteSegment){
      this.createProcedureCoordinatePointsFromFileContent();
    } else {
      this.modalService.showMesssageModal("Import successful", "The Route Segments were imported successfully.");
    }
  }

  createProcedureCoordinatePointsFromFileContent() : void {
    let routeSegments : Map<String,Route> = new Map();

    this.routeSegmentsService.isCreateProcedureFromRouteSegment = false;
    let feats : Feature<Geometry>[] = this.routeSegmentsService.createFeaturesFromXMLContent();
    feats.forEach( feat => {
      let newSegment: Segment = this.routeSegmentsService.transformFeatureInSegment(feat, this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857");
      if(!routeSegments.get(newSegment.routeDesignation)){
        let newRoute : Route = new Route();
        newRoute.designation = newSegment.routeDesignation;
        newRoute.segments.push(newSegment);
        routeSegments.set(newSegment.routeDesignation, newRoute);
      } else {
        let route : Route = routeSegments.get(newSegment.routeDesignation);
        route.segments.push(newSegment);
      }
    });

    let continuityErrorOneRoute : boolean = false;
      routeSegments.forEach((value: Route, key: string) => {
        this.routeSegmentsService.calculateRouteSegmentsContinuity(value);
        if(routeSegments.size == 1 && !value.continuous){
          continuityErrorOneRoute = true;
          this.modalService.showMesssageModal("Create Procedure from Route Segments","None of the routes corresponding to the selected segments are continuous, please redo the selection.");
          return;
        }
      });

      if (routeSegments.size > 0){
        if(!continuityErrorOneRoute){
          const bsModalRef : BsModalRef = this.bsModalRef.show(CreateProcedureFromRouteSegmentComponent, {
            backdrop: 'static' // Prevent closing on backdrop click
          });
          bsModalRef.content.routeSegments = routeSegments;
        }
      } else {
        this.modalService.showMesssageModal("Create Procedure from Route Segments","Select at least one route segment.");
      }

    this.bsModalRef.hide();
  }


}
